exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.side-menu {\n  position: relative;\n  height: 100%;\n}\n", ""]);

